import React, { useState } from 'react';
import TenantCard from './card';
import TenantPopup from './popup';
import { useTenants } from '../../hook/useTenents';
import { FaSpinner } from 'react-icons/fa';


type TenantForEdit = {
  id: number;
  name: string;
  contact: string;
  email: string;
  propertyAddress: any;
  propertyName?:string;
  dueDate: string;
  occupiedDate: string;
  vacatedDate: string;
  rentStatus: "PAID" | "UNPAID";
  depositAmount: number;
  openingBalance: number | null;
  rent: number;
  occupation: string;
  documentUrl: string | null;
  comments: string | null;
  tenantImageUrl: string | null;
  active: boolean;
}
const TenantList = ({ tenants,loading, setSelectedTenants ,setDeletPopup,setActiveTenantID,setIsEditMode,setOpenPopup}: {loading:boolean; tenants: Tenant[],setSelectedTenants:(value:TenantForEdit) =>void,setOpenPopup:(value:any) =>void,setDeletPopup:(value:boolean) =>void, setActiveTenantID:(value:any) =>void,setIsEditMode:(value:boolean) =>void}) => {

  const {deleteTenant} =  useTenants()
  const [selectedTenant, setSelectedTenant] = useState<Tenant | null>(null);

  const handleViewDetails = (tenant: Tenant) => {
    setSelectedTenant(tenant);
  };
  const handleEdit = (tenant: Tenant, tenantID: any) => {
    setActiveTenantID(tenantID);
    setIsEditMode(true);
    setOpenPopup(true)
    setSelectedTenants({...tenant,propertyAddress:tenant.propertyAddress.id,propertyName:tenant.propertyAddress.propertyName})
  };
  const handleDelete = (tenantID: any) => {
    setActiveTenantID(tenantID);
   setDeletPopup(true)
  };
  const handleClosePopup = () => {
    setSelectedTenant(null);
  };
  if (loading) {
    return (
      <div className="h-full w-full justify-center flex items-center">
        <p className="flex gap-1 justify-center   text-black items-center">
          <FaSpinner className="animate-spin mr-2" /> Loading...
        </p>
      </div>
    );
  }
  if (tenants.length==0) {
    return (
      <div className="h-full w-full text-black justify-center flex items-center">
      <p>No Data</p>
      </div>
    );
  }
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {tenants?.map((tenant) => (
        <TenantCard
          key={tenant.id}
          tenant={tenant}
          onViewDetails={() => handleViewDetails(tenant)}
          onEdit={() => handleEdit(tenant,tenant.id)}
          onDelete={() => handleDelete( tenant.id)}
        />
      ))}
      {selectedTenant && (
        <TenantPopup tenant={selectedTenant} onClose={handleClosePopup} />
      )}
    </div>
  );
};

export default TenantList;
